import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faRotate, faRotateLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
import logo from '../../../assets/img/reactlogo.png';
const today = new Date().toISOString().split('T')[0];
// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: '#ffffff'
  },
  section: {
    marginBottom: 5
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5
  },
  headerText: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: "center"
  },
  image: {
    width: 100
  },
  provider: {
    height: 50
  },
  date: {
    fontSize: 12,
    textAlign: 'right'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableRow: {
    flexDirection: "row"
  },
  tableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0'
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableCellHeader: {
    margin: 6,
    fontSize: 11,
    fontWeight: "bold"
  },
  tableCell: {
    margin: 6,
    fontSize: 11
  },
  footerContainer: {
    marginTop: 20
  },
  companyMainText: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  companyText: {
    fontSize: 9
  },
  totalCost: {
    fontSize: 12,
    fontWeight: 'bold'
  },
});

function ImeReport() {
  const [currentDate, setCurrentDate] = useState('');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [data1, setData1] = useState(false);
  const [recordData, setRecordData] = useState(false);
  const [users, setUsers] = useState(false);
  const [otpToken, setOtpToken] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [singleTransectionRow, setSingleTransectionRow] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setEditModal(false);
    setDeleteModal(false)
  };
  const handleShow = () => setShowModal(true);

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const ReloadAllTransaction = async () => {
    try {
      const response = await axios.post("/v2/imeremittance/transaction/inqueryAll");
      const { status, message } = response.data;
      toast(message);
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const PrintPDF = () => (
    typeof window !== 'undefined' && (<Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.headerContainer}>
            <Image style={styles.image} src={logo} />
            <Text style={styles.headerText}>Transaction Summary</Text>
            {
              data && singleTransectionRow && singleTransectionRow.map(data => (
                data.key == "Provider" &&
                data.val

              ))
            }
          </View>
          <View>
            <Text style={styles.companyMainText}>Pargati online service PVT LTD, SCO 832, 2nd floor, Cabin no. 10, NAC Manimajra Chandigah</Text>
            <Text style={styles.companyText}>Office Working Days: Monday To Saturday</Text>
            <Text style={styles.companyText}>Timing: 10:00 AM To 6:00 PM</Text>
            <Text style={styles.companyText}>Help Line: 01724049681</Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Recharge Report</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Detail</Text>
            </View>
          </View>
          {
            data && singleTransectionRow && singleTransectionRow.map(data => (
              data.key != "Provider" && (
                <View style={styles.tableRow}>
                  <View style={styles.tableColHeader}>
                    <Text style={styles.tableCellHeader}>{data.key}:</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{data.val}</Text>
                  </View>
                </View>
              )
            ))
          }
        </View>
      </Page>
    </Document>)
  );
  const handleSearch = async (e) => {
    e.preventDefault();
    const { user_id, sender_registered_by, payment_mode, status, icn_number, start_date, end_date } = e.target;
    let rechargeData = {
      user_id: userId,
      start_date: start_date.value,
      end_date: end_date.value,
      sender_registered_by: sender_registered_by.value,
      payment_mode: payment_mode.value,
      status: status.value,
      icn_number: icn_number.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      user_id: pageData.user_id,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
      sender_registered_by: pageData.sender_registered_by,
      payment_mode: pageData.payment_mode,
      status: pageData.status,
      icn_number: pageData.icn_number,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/imeReport", requestData);
      const { status, data, records, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setRecordData(records);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const RefreshStatus = async (e, reference_number) => {
    e.preventDefault();
    try {
      const response = await axios.post("/v2/imeremittance/transaction/inquery", { icn_number: reference_number });
      const { status, message } = response.data;
      toast(message);
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const MakeRefund = async (e, reference_number) => {
    e.preventDefault();
    try {
      const response = await axios.post("/v2/imeremittance/makeRefund", { icn_number: reference_number });
      const { status, message } = response.data;
      toast(message);
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getEditModal = async (e, rowIndex) => {
    e.preventDefault();
    setData1(data && data.data[rowIndex]);
    setEditModal(true);
  };

  const getDeleteModal = async (e, rowIndex) => {
    e.preventDefault();
    setData1(data && data.data[rowIndex]);
    setDeleteModal(true);
  };

  const editSubmit = async (e) => {
    e.preventDefault();
    const {
      reference_number,
      ReceiverName,
      ReceiverGender,
      receiver_address,
      receiver_state,
      receiver_district,
      receiver_municipality,
      Relationship,
      PurposeOfRemittance,
      SourceOfFund,
      ReceiverMobileNo,
      bank_id,
      bank_branch_id,
      account_number,
      otp
    } = e.target;
    try {
      if (!otp) {
        const response = await axios.post("/v2/imeremittance/send/otp", { action: "MT", icn_number: reference_number.value });
        const { status, message, data } = response.data;
        toast(message);
        if (status) {
          setOtpToken(data.otptoken);
        }
      }
      else {
        let reqData = {
          icn_number: reference_number.value,
          receiver_name: ReceiverName.value,
          receiver_gender: ReceiverGender.value,
          receiver_address,
          receiver_state,
          receiver_district,
          receiver_municipality,
          relationship: Relationship.value,
          remittance_reason: PurposeOfRemittance.value,
          source_of_fund: SourceOfFund.value,
          receiver_mobile: ReceiverMobileNo.value,
          bank_id,
          bank_branch_id,
          account_number,
          otp: otp.value,
          otp_token: otpToken,
        };
        const response = await axios.post("/v2/imeremittance/modify/transaction", reqData);
        const { status, message } = response.data;
        toast(message);
        if (status) {
          handleClose();
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const deleteSubmit = async (e) => {
    e.preventDefault();
    const { reference_number, cancel_reason, otp } = e.target;
    try {
      if (!otp) {
        const response = await axios.post("/v2/imeremittance/send/otp", { action: "CT", icn_number: reference_number.value });
        const { status, message, data } = response.data;
        toast(message);
        if (status) {
          setOtpToken(data.otptoken);
        }
      }
      else {
        let reqData = {
          icn_number: reference_number.value,
          cancel_reason: cancel_reason.value,
          otp: otp.value,
          otp_token: otpToken,
        };
        const response = await axios.post("/v2/imeremittance/cancel/transaction", reqData);
        const { status, message } = response.data;
        toast(message);
        if (status) {
          handleClose();
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const GeneratePDF = async (e, reference_number) => {
    e.preventDefault();
    try {
      const response = await axios.post("/generate/remittPdf/ime", { icn_number: reference_number });
      const { status, file } = response.data;
      if (status) {
        window.open(file, '_blank');
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const changeData = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setData1({ ...data1, [name]: value });
  };

  const getData1 = async () => {
    try {
      const response = await axios.get("/get/all/users");
      const { status, users } = response.data;
      if (status) {
        setUsers(users);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    //getData1();
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setCurrentDate(today);
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Transfer Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />
                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>Sender Registered By</label>
                    <select class="form-control" name="sender_registered_by">
                      <option value="">--Select--</option>
                      <option value="kyc">Aadhaar Card</option>
                      <option value="normal">Citizenship</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>Payment Mode</label>
                    <select class="form-control" name="payment_mode">
                      <option value="">--Select--</option>
                      <option value="B">Account Deposit</option>
                      <option value="C">Cash Payment</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>ICN Number</label>
                    <input class="form-control" type="text" name="icn_number" />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>Status</label>
                    <select class="form-control" name="status">
                      <option value="">--Select--</option>
                      <option value="Paid">Paid</option>
                      <option value="Un-Paid">Un-Paid</option>
                      <option value="Post">Post</option>
                      <option value="Compliance">Compilance</option>
                      <option value="Cancel">Cancel</option>
                      <option value="Refund">Refund</option>
                      <option value="transaction_sent">Transaction Sent</option>
                      <option value="pending">Pending</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" value={currentDate} max={today} onChange={(e) => setCurrentDate(e.target.value)} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      IME History
                    </h4>
                    <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Collected Amount</strong></label>
                        <div>NPR {(recordData?.totalCollectAmount * 1.6).toFixed(2)}(₹ {(recordData?.totalCollectAmount).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Send Amount</strong></label>
                        <div>NPR {(recordData?.payoutAmount).toFixed(2)}(₹ {(recordData?.payoutAmount / 1.6).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Service Charge</strong></label>
                        <div>NPR {(recordData?.serviceRecharges * 1.6).toFixed(2)}(₹ {(recordData?.serviceRecharges).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total IME Commission</strong></label>
                        <div>NPR {(recordData?.totalIMECommission * 1.6).toFixed(2)}(₹ {(recordData?.totalIMECommission).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total TDS Debited</strong></label>
                        <div>NPR {(recordData?.totalTDSDebited * 1.6).toFixed(2)}(₹ {(recordData?.totalTDSDebited).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total IME Remittance</strong></label>
                        <div>{recordData?.totalIMERemittance}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Refresh Records</strong></label>
                        <div><Link onClick={ReloadAllTransaction}><FontAwesomeIcon icon={faRotate} className="refreshRecords" title="Reload" /></Link></div>
                      </div>
                    </div>
                    <DataTable
                      value={data.data}
                      size="small"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="mobile"
                        header="Agent(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.user_id?.name}<br />({rowData?.user_id?.mobile})</span>}
                      />
                      <Column
                        field="mobile"
                        header="Receiver(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.ReceiverName}<br />({rowData?.ReceiverMobileNo})</span>}
                      />
                      <Column
                        field="mobile"
                        header="Sender(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.sender_id?.FirstName}<br />({rowData?.sender_id?.MobileNo})</span>}
                      />
                      <Column
                        field="collected_amount"
                        header="Collected Amount"
                        sortable
                        body={(rowData) => <span data-label="Amount">{rowData.CollectAmount}</span>}
                      />
                      <Column
                        field="send_amount"
                        header="Send Amount"
                        sortable
                        body={(rowData) => <span data-label="Amount">{rowData.PayoutAmount}</span>}
                      />
                      <Column
                        field="service_charge"
                        header="Service Charges(₹)"
                        sortable
                        body={(rowData) => <span data-label="ServiceCharges">{rowData.service_charge}</span>}
                      />
                      <Column
                        field="reference_number"
                        header="ICN Number"
                        sortable
                        body={(rowData) => <span data-label="ICNNumber">{rowData.reference_number}</span>}
                      />
                      <Column
                        field="method"
                        header="Method"
                        sortable
                        body={(rowData) => <span data-label="Method">{rowData.PaymentType == "B" ? "Bank" : "Cash"}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData.status}</span>}
                      />
                      <Column
                        field="ime_commission"
                        header="IME Commission Credited"
                        sortable
                        body={(rowData) => <span data-label="IMECommissionCredited">{rowData?.user_id?.ime_commission}</span>}
                      />
                      <Column
                        field="ime_tds_debited"
                        header="IME Tds Debited"
                        sortable
                        body={(rowData) => <span data-label="IMETdsDebited">{rowData?.user_id?.ime_commission == 0 ? 0 : 2.1}</span>}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <Link onClick={(e) => RefreshStatus(e, rowData?.reference_number)}><FontAwesomeIcon icon={faRotate} className="successIcon" title="Refresh" /></Link>
                              <Link onClick={(e) => getEditModal(e, rowIndex)}><FontAwesomeIcon icon={faPenToSquare} className="successIcon" title="Edit" /></Link>
                              <Link onClick={(e) => getDeleteModal(e, rowIndex)}><FontAwesomeIcon icon={faTrash} className="successIcon" title="Delete" /></Link>
                              <Link onClick={(e) => GeneratePDF(e, rowData?.reference_number)}><FontAwesomeIcon icon={faFilePdf} className="successIcon" title="PDF" /></Link>
                              <Link onClick={(e) => MakeRefund(e, rowData?.reference_number)}><FontAwesomeIcon icon={faRotateLeft} className="successIcon" title="RotateLeft" /></Link>
                              {/* <button className="btn btn-primary" onClick={(e) => RefreshStatus(e, rowData?.reference_number)}>
                                Refresh
                              </button>
                              <button className="btn btn-primary" onClick={(e) => getEditModal(e, rowIndex)}>
                                Edit
                              </button>
                              <button className="btn btn-primary" onClick={(e) => getDeleteModal(e, rowIndex)}>
                                Delete
                              </button>
                              <button className="btn btn-primary" onClick={(e) => GeneratePDF(e, rowData?.reference_number)}>
                                PDF
                              </button> */}
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Transection Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {
              data && singleTransectionRow && (
                <ul className="showData">
                  {
                    singleTransectionRow.map(data => (
                      data.key != "Provider" && (
                        <li>
                          <strong>{data.key}:</strong>
                          <div>{data.val}</div>
                        </li>
                      )
                    ))
                  }
                </ul>
              )
            }
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {typeof window !== 'undefined' && showModal && (
            <PDFDownloadLink className="btn btn-primary" document={<PrintPDF />} fileName="mypdf.pdf">
              {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : 'Print'
              }
            </PDFDownloadLink>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={editModal} onHide={handleClose} centered size='xl' backdrop="static">
        <Form onSubmit={editSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Transaction</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input type="hidden" name="reference_number" value={data1.reference_number} />
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Receiver Mobile Number</label>
                    <input className="form-control" type="number" name="ReceiverMobileNo" value={data1.ReceiverMobileNo} onChange={changeData} requiredField="true" />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Receiver Name</label>
                    <input className="form-control" type="text" name="ReceiverName" value={data1.ReceiverName} onChange={changeData} requiredField="true" />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Receiver Gender</label>
                    <select className="form-control" name="ReceiverGender" value={data1.ReceiverGender} onChange={changeData} requiredField="true">
                      <option value="1801">Male</option>
                      <option value="1802">Female</option>
                      <option value="1803">Other</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Source of Fund</label>
                    <select className="form-control" name="SourceOfFund" value={data1.SourceOfFund} onChange={changeData} requiredField="true">
                      <option value="8051">Salary</option>
                      <option value="8052">Business</option>
                      <option value="8070">Salary / Wages</option>
                      <option value="8071">Bonus / Commission</option>
                      <option value="8073">Savings or accumulated</option>
                      <option value="8074">Part time job</option>
                      <option value="8075">Own business</option>
                      <option value="8076">Investment</option>
                      <option value="8077">Lottery</option>
                      <option value="8078">Gifts and donation</option>
                      <option value="8079">Loan from bank</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Relationship</label>
                    <select class="form-control" name="Relationship" value={data1.Relationship} onChange={changeData} requiredField="true">
                      <option value="2101">Father</option>
                      <option value="2102">Mother</option>
                      <option value="2103">Grand Father</option>
                      <option value="2104">Grand Mother</option>
                      <option value="2105">Husband</option>
                      <option value="2106">Wife</option>
                      <option value="2107">Father in Law</option>
                      <option value="2108">Mother in Law</option>
                      <option value="2109">Brother</option>
                      <option value="2110">Brother in Law</option>
                      <option value="2111">Sister</option>
                      <option value="2112">Sister in Law</option>
                      <option value="2113">Son</option>
                      <option value="2114">Daughter</option>
                      <option value="2115">Uncle</option>
                      <option value="2116">Aunty</option>
                      <option value="2117">Cousin</option>
                      <option value="2118">Nephew</option>
                      <option value="2119">Niece</option>
                      <option value="2120">Friend</option>
                      <option value="2121">Self</option>
                      <option value="8011">Spouse</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Purpose of Remittance</label>
                    <select className="form-control" name="PurposeOfRemittance" value={data1.PurposeOfRemittance} onChange={changeData} requiredField="true">
                      <option value="3801">Family Maintenance</option>
                    </select>
                  </div>
                  {
                    otpToken && (
                      <div className="col-lg-4 col-md-4">
                        <label>OTP</label>
                        <input className="form-control" name="otp" required />
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={deleteModal} onHide={handleClose} centered size='sm' backdrop="static">
        <Form onSubmit={deleteSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Transaction</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input type="hidden" name="reference_number" value={data1.reference_number} />
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <label>Cancel Reason</label>
                    <select className="form-control" name="cancel_reason" required>
                      <option value="">Select Reason</option>
                      <option value="7701">Sender Has Cancel by themselves</option>
                      <option value="7703">Remittance Amount is wrong</option>
                      <option value="7704">Beneficiary is unable to collect the funds</option>
                    </select>
                  </div>
                  {
                    otpToken && (
                      <div className="col-lg-12 col-md-12">
                        <label>OTP</label>
                        <input className="form-control" name="otp" required />
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

    </div>
  );
}

export default ImeReport;
